import { FC, useEffect, useState } from "react";
import ConfettiExplosion, { ConfettiProps } from "react-confetti-explosion";
import "../styles.css";
import { colors, getKeys, getRandomValue } from "../utils";

interface IGameView {
  points: number;
  addPoint: () => void;
  loseGame: () => void;
}

const largeProps: ConfettiProps = {
  force: 0.8,
  duration: 3000,
  particleCount: 400,
  width: 2400,
  colors: ["#041E43", "#1471BF", "#5BB4DC", "#FC027B", "#66D805"],
};

const BigRedX = () => {
  return <div className="big-x">X</div>;
};

const GameView: FC<IGameView> = (props) => {
  const { points, addPoint, loseGame } = props;

  const [isExploding, setIsExploding] = useState(false);
  const [isWrong, setIsWrong] = useState(false);
  const [[correct, incorrect], setKeys] = useState<(keyof typeof colors)[]>(
    getKeys()
  );
  const [isLeft, setIsLeft] = useState<boolean>(getRandomValue() === 1);

  useEffect(() => {
    if (isWrong) {
      setTimeout(() => {
        setIsWrong(false);
        loseGame();
      }, 1500);
    }
    if (isExploding) {
      setTimeout(() => {
        setIsExploding(false);
        handleNextRount();
      }, 3000);
    }
  }, [isWrong, isExploding, loseGame]);

  const explode = () => {
    setIsExploding(!isExploding);
  };

  const handleClickButton = (btn: "left" | "right") => () => {
    if ((isLeft && btn === "left") || (!isLeft && btn === "right")) {
      explode();
      addPoint();
    } else {
      setIsWrong(true);
    }
  };

  const handleNextRount = () => {
    setKeys(getKeys());
    setIsLeft(getRandomValue() === 1);
  };

  return (
    <>
      {isExploding && <ConfettiExplosion {...largeProps} />}
      {isWrong && <BigRedX />}
      {isExploding || isWrong ? <div className="overlay" /> : null}

      <div className="points-bar">
        <span className="points">PUNTOS: {points ?? 0}</span>
      </div>

      <div className="view">
        <span className="color-name">{colors[correct]}</span>

        <div className="buttons">
          <button
            className="button-color"
            style={{
              backgroundColor: isLeft ? correct : incorrect,
              color: ["white", "pink", "yellow", "gray"].includes(
                isLeft ? correct : incorrect
              )
                ? "black"
                : "white",
            }}
            onClick={handleClickButton("left")}
          >
            ?
          </button>
          <button
            className="button-color"
            style={{
              backgroundColor: !isLeft ? correct : incorrect,
              color: ["white", "pink", "yellow", "gray"].includes(
                !isLeft ? correct : incorrect
              )
                ? "black"
                : "white",
            }}
            onClick={handleClickButton("right")}
          >
            ?
          </button>
        </div>
      </div>
    </>
  );
};

export default GameView;
